module.exports = __webpack_public_path__ + "fonts/Rockstar-ExtraBold.0f2c4c39.otf";